import { render, staticRenderFns } from "./Naw0.vue?vue&type=template&id=570a4bac&scoped=true&"
import script from "./Naw0.vue?vue&type=script&lang=js&"
export * from "./Naw0.vue?vue&type=script&lang=js&"
import style0 from "./Naw0.vue?vue&type=style&index=0&id=570a4bac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570a4bac",
  null
  
)

export default component.exports